exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-footer .footer[data-v-331ca876]{background-color:#292c32;color:#fff;clear:both;width:100%;max-width:100%}.lp-footer[data-v-331ca876]{width:100%}.footer[data-v-331ca876]{padding-bottom:3rem;margin:0}.lp-title[data-v-331ca876]{color:#a0a0a0;margin-bottom:1.3rem}.lp-cont[data-v-331ca876]{color:#fff;font-size:.9rem;margin-bottom:8px}a[data-v-331ca876]{color:#fff;cursor:pointer}a[data-v-331ca876]:hover{color:#ccc}@media (max-width:768px){.lp-footer[data-v-331ca876]{border-top:none}}.column[data-v-331ca876]{padding:0}", ""]);

// exports
